import type { SVGProps } from 'react';
const SvgAddBusiness = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#add_business_svg__a)">
      <path d="M15 17h2v-3h1v-2l-1-5H2l-1 5v2h1v6h9v-6h4v3Zm-6 1H4v-4h5v4ZM17 4H2v2h15V4Z" />
      <path d="M20 18v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z" />
    </g>
    <defs>
      <clipPath id="add_business_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAddBusiness;
